import {
    FormControl,
    MenuItem,
    TextField,
    InputLabel,
    Tooltip,
} from '@mui/material';

import { QuestionCircleOutlined } from '@ant-design/icons';
import InputAdornment from '@mui/material/InputAdornment';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { makeStyles } from '@mui/styles';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
const Size = window.innerHeight < 950 ? "small" : undefined;
const InputLabelProps = { className: "test-label", shrink: false }
const Go2RFC = () => window.open('https://www.finbeabc.com.mx','_blank');


const useStyles = makeStyles(() => ({
    input: {
      '&::-webkit-calendar-picker-indicator': {
        filter: 'invert(1)',
        color: 'white',
      },
    },
  }));

function validetaStyleAdorment(validate: boolean | undefined): Object {
    if (validate !== undefined) {
        if (validate) {
            return { cursor: 'pointer' };
        }
        else {
            return { cursor: 'pointer', color: 'red' };
        }
    }
    else {
        return { cursor: 'pointer' };
    }
}


export const InputDefault = ({
    label,
    maxlength,
    minlength,
    endAdorment,
    onChange,
    validate,
    helperText,
    disabled,
    value,
    isPrice,
    isNumber,
    isPorcent,
    withTooltip,
    TooltipLabel,
    isOnlyNumber,
    fullWidth }: InputProps) => (
    <TextField
        error={validate !== undefined ? !validate : undefined}
        helperText={validate !== undefined ? !validate && helperText : undefined}
        label={label}
        disabled={disabled}
        value={value}
        type={isNumber || isOnlyNumber ? 'number' : undefined}
        inputProps={{ 
            maxLength: maxlength ? maxlength : 256, 
            minlength: minlength ? minlength : 0
        }}
        onChange={({ target }) => onChange(target.value)}
        InputProps={{
            endAdornment: endAdorment &&
                (<InputAdornment
                    position="end"
                    style={validetaStyleAdorment(validate)}>
                    {
                        withTooltip ? (
                            <Tooltip
                                placement='bottom'
                                title={TooltipLabel || ''}
                            >
                                <QuestionCircleOutlined />
                            </Tooltip>
                        ) :
                        (
                            <QuestionCircleOutlined/>
                        )
                    }
                </InputAdornment>),
            startAdornment: 
                isNumber && 
                (<InputAdornment position='start'>
                    {isPrice ? "$" : 
                        isPorcent ? "%" :
                        undefined}
                </InputAdornment>)
        }}
        size={Size}
        fullWidth={!fullWidth}
        InputLabelProps={{ ...InputLabelProps, shrink:true }} />
)

export const InputPrice = ({
    label,
    maxlength,
    onChange,
    disabled,
    value,
    TooltipLabel,
    withTooltip,
    endAdorment,
    fullWidth
}: InputProps) => (
    <NumericFormat
        label={label}
        disabled={disabled}
        value={value}
        customInput={TextField} // Usa un componente TextField como entrada personalizada
        decimalScale={2} // Especifica la cantidad de decimales
        thousandSeparator={true} // Habilita el separador de miles
        onValueChange={({ floatValue }) => onChange(floatValue)} // Manejador de cambio de valor
        InputProps={{
            startAdornment: 
                (<InputAdornment style={{marginTop: 4}} position='start'> $</InputAdornment>)
        }}
        size={Size}
        fullWidth={!fullWidth}
        InputLabelProps={{ ...InputLabelProps, shrink: true }}
    />
);

export const NumericInput = ({
    label,
    maxlength,
    minlength,
    onChange,
    disabled,
    value,
    fullWidth,
    isPrice,
    isPorcent,
}: InputProps) => (
    <NumericFormat
        label={label}
        disabled={disabled}
        value={value}
        customInput={TextField} 
        decimalScale={2} 
        thousandSeparator={isPrice? true : false} 
        onChange={({ target }) => onChange(target.value)}
        inputProps={{ 
            maxLength: maxlength ? maxlength : 256, 
            minlength: minlength ? minlength : 0
        }}
        InputProps={{
                startAdornment: 
                (<InputAdornment position='start'>
                    {isPrice ? "$" : 
                        isPorcent ? "%" :
                        undefined}
                </InputAdornment>)
        }}
        size={Size}
        fullWidth={!fullWidth}
        InputLabelProps={{ ...InputLabelProps, shrink: true }}
    />
);

export const InputSelect = ({ label, endAdorment, listItems, setValue, value, disabled, style}: InputSelectProps) => (
    <FormControl fullWidth size={Size} disabled={disabled}>
        <InputLabel className='test-label'>{label}</InputLabel>
        <Select
            label={label}
            style={{ color: "white" }}
            value={value}
            onChange={(event: SelectChangeEvent) => setValue(event.target.value)} 
            MenuProps={{
                PaperProps: {
                    sx: {
                        maxWidth:"45%",
                    }
                }
            }}
        >
            {
                listItems.map((data: { id: any, name: String }) => (<MenuItem style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word"
                }} value={data.id}>{data.name}</MenuItem>))
            }
        </Select>
    </FormControl>
)

export const InputDate = ({
    label,
    onChange,
    disabled,
    value,
    endAdorment,
    fullWidth,
    validate,
  }: InputProps) => {
    const classes = useStyles();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const maxDate = yesterday.toISOString().split("T")[0];
    return (
      <TextField
        error={validate !== undefined ? !validate : undefined}
        label={label}
        type="date"
        disabled={disabled}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        inputProps={{ max: maxDate }}
        InputProps={{
          endAdornment: endAdorment && (
            <InputAdornment position="end">
            </InputAdornment>
          ),
          classes: { input: classes.input }, 
        }}
        size={Size}
        fullWidth={!fullWidth}
        InputLabelProps={{ ...InputLabelProps, shrink: true }}
      />
    );
  };
  
  export const InputSelectContact = ({ label, endAdorment, listItems, setValue, value, disabled }: InputSelectProps) => (
    <FormControl fullWidth size={Size} disabled={disabled}>
        <InputLabel className='test-label'>{label}</InputLabel>
        <Select
            label={label}
            style={{ color: "white" }}
            value={value}
            onChange={(event: SelectChangeEvent) => setValue(event.target.value)} >
            {
                listItems.map((data: { id: any, name: String }) => (<MenuItem value={data.id}>{data.name}</MenuItem>))
            }
        </Select>
    </FormControl>
)

type InputProps = {
    label: string,
    maxlength?: number,
    minlength?: number,
    endAdorment?: boolean,
    onChange: Function,
    validate?: boolean,
    helperText?: string,
    disabled?: boolean,
    value?: string | number,
    isPrice?: boolean,
    isPorcent?: boolean,
    isNumber?: boolean,
    withTooltip?: boolean,
    TooltipLabel?: string,
    fullWidth?: boolean,
    isOnlyNumber?: boolean,
}

type InputSelectProps = {
    label: string,
    endAdorment?: boolean,
    listItems: { id: Number, name: String }[],
    setValue: Function,
    value: any,
    disabled?: boolean,
    style?: React.CSSProperties

}